export const UPLOAD_OPTIONS = {
  MAX_UPLOAD_COUNT: 200, // 200 files at one time
  MAX_FILE_SIZE: 4000 * 1024 * 1024, // 4Gb
  MD5_SIZE_LIMIT: 50 * 1024 * 1024 // 50MB
};
